<template>
  <v2-row noSpace class="w-full items-center">
    <v2-delete-modal
      :startHtmlScrollToggle="true"
      :name="'delete-file-approval-file-modal' + item.uid"
      :title="$t('quickLaunch.modals.deleteModal.title')"
      :text="$t('library.modals.deleteLibraryFile.text')"
      :deleteHandler="
        () => {
          deleteFileApprovalAttachmentRelation();
        }
      "
    ></v2-delete-modal>
    <v2-col col1 noSpaceX noSpace>
      <div style="width: 50px; height: 100%" v-if="item.display_type !== 'label'">
        <div v-if="!isReady" style="width: 50px; height: 50px" class="relative">
          <v-spinner slot="value" size="10" :loading="true" bgColor="rgba(241, 242, 246, 1)"></v-spinner>
        </div>
        <div v-if="isConverted" :style="thumbnailStyles" class="flex justify-center">
          <v-lazy-load :image="imageUrl"></v-lazy-load>
        </div>
      </div>
    </v2-col>
    <v2-col col10 noSpace>
      <div class="flex">
        <div>
          <span :class="[isSmView ? 'line-clamp-1 break-all' : '']">{{ item.title }}</span>
          <div class="text-v2-grey-light text-xs" v-if="item.display_type !== 'label'">
            <span>{{ $h.formatDate(item.created_at, timezone) + " | " }}</span>
            <span class="uppercase">{{ item.file_extension + " | " }}</span>
            <span>{{ $h.formatFileSize(item.file_size) }}</span>
            <span v-if="!isConverted">{{ " | " + $t("stati.files.text." + currentStatus) }}</span>
          </div>
        </div>
        <span>
          <v2-awesome-icon
            v-if="item.first_seen_at"
            class="mx-1"
            name="eye"
            color="gray"
            :title="
              $t('fileapproval.labels.fileSeenTimestampLabel', {
                date: $h.formatDate(item.first_seen_at, timezone, false, true),
                time: $h.formatTime(item.first_seen_at, timezone, false),
              })
            "
          />
          <v2-awesome-icon
            v-if="item.first_download_at"
            class="mx-1"
            name="download"
            color="gray"
            :title="
              $t('fileapproval.labels.fileDownloadTimestampLabel', {
                date: $h.formatDate(item.first_download_at, timezone, false, true),
                time: $h.formatTime(item.first_download_at, timezone, false),
              })
            "
          />
        </span>
      </div>
      <!--div><span><a class="secondary" :href="fileApprovalAttachmentFile.url">Download</a></span></div-->
    </v2-col>
    <v2-col col1 noSpace noSpaceX class="min-h-full flex items-end">
      <v2-button
        :title="$t('fileapproval.buttons.deleteFileApproval')"
        ghostProgress
        outline
        icon
        iconWarning
        sm
        :class="{ 'ml-2 mr-4': !isSmView }"
        v-if="isRemovable"
        @click.native="openDeleteFileModal"
      >
        <v2-icon :data="require('@icon/Icon=trash.svg')" color="#f03e3e" width="20px" height="20px"></v2-icon>
      </v2-button>
    </v2-col>
  </v2-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import globalMixin from "@/mixins/global.js";

export default {
  name: "FileApprovalFileListItem",
  mixins: [globalMixin],
  props: {
    fileApprovalAttachmentFile: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    projectUid: {
      type: String,
      required: true,
    },
    fileApprovalUid: {
      type: String,
      required: true,
    },
    fileApprovalVersion: {
      type: Object,
      required: true,
    },
    isRemovable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      item: {},
      amountTry: 10,
      timeWaitStart: 3000,
      timer: null,
      imageUrl: "",
      thumbnailStyles: this.isSmView ? "width: 30px; height: 30px;" : "width: 50px; height: 50px;",
    };
  },
  created() {
    this.item = this.fileApprovalAttachmentFile;
    if (this.item.display_type === "image") this.untilReady();
  },
  mounted() {
    this.thumbnailStyles = this.isSmView ? "width: 30px; height: 30px;" : "width: 50px; height: 50px;";
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    ...mapActions(["fileApprovalApiRequest", "updateFileApprovalVersionAttachmentRelation"]),
    isConvertedCalculate(item) {
      return this.statiBits ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item.status) {
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    getItemPreview() {
      let vm = this;

      const payload = {
        apiMethod: "fileApprovalAttachmentPreviewUrl",
        params: {
          project: vm.projectUid,
          file: vm.item.uid,
          page: 1,
          width: "100",
          height: "100",
          rendermethod: "fit",
          redirect: false,
        },
      };
      if (this.isConverted && this.item.preview.image) {
        vm.fileApprovalApiRequest(payload)
          .then((file) => {
            this.imageUrl = file.redirect;
            console.log("get file preview", file);
          })
          .catch((err) => {
            console.log("error: ", err);
          });
      } else {
        this.imageUrl = "";
      }
    },
    untilReady() {
      console.log("=====>>>>>> UNTILREADY");
      this.getItemPreview();
      if (!this.isReady) {
        const vm = this;
        vm.timer = setTimeout(function () {
          let payload = {
            apiMethod: "fileApprovalAttachmentGet",
            params: {
              project: vm.projectUid,
              file: vm.item.uid,
            },
          };

          vm.fileApprovalApiRequest(payload)
            .then((response) => {
              console.log("get file", response);
              vm.item = response;
              vm.amountTry = vm.amountTry - 1;
              if (vm.amountTry <= 0) {
                vm.amountTry = 10;
                vm.timeWaitStart = vm.timeWaitStart + 60000;
              }
              vm.untilReady();
            })
            .catch();
        }, vm.timeWaitStart);
      }
    },
    openDeleteFileModal() {
      this.$modal.show("delete-file-approval-file-modal" + this.item.uid);
    },
    deleteFileApprovalAttachmentRelation() {
      let vm = this;

      let payloadData = {
        remove_from_version: vm.fileApprovalVersion.uid,
      };

      vm.updateFileApprovalAttachmentRelation(payloadData);
    },
    updateFileApprovalAttachmentRelation(payloadData) {
      let vm = this;

      const payload = {
        params: {
          project: vm.projectUid,
          file: vm.item.uid,
        },
        data: payloadData,
      };

      vm.updateFileApprovalVersionAttachmentRelation(payload)
        .then(() => {
          this.$modal.hide("delete-file-approval-file-modal" + this.item.uid);
          vm.$snotify.success(vm.$t("fileapproval.toasts.deleteFile.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });

          vm.$eventbus.$emit("fileApprovalListReloadEvent");
        })
        .catch((err) => {
          vm.$snotify.error(vm.$t("fileapproval.toasts.deleteFile.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });

          console.log("error: ", err);
        });
    },
  },
  computed: {
    isConverted() {
      return this.isConvertedCalculate(this.item);
    },
    isReady() {
      return this.isReadyCalculate(this.item);
    },
    currentStatus() {
      return this.statiBits && this.item ? this.$h.globalGetCurrentFileStatus(this.item.status, this.statiBits) : "";
    },
    ...mapGetters({
      statiBits: "global_get_fileStatiBits",
    }),
  },
};
</script>
